module.exports = __webpack_public_path__ + "static/media/fly0177.7c69b258.webp";